import Vue from 'vue'

import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import '../public/style.css';

import Date from "@/filters/Date.js"
import DateTime from "@/filters/DateTime.js"

import MbAlert from "@/components/ui/modal/MbAlert"
import MbConfirm from "@/components/ui/modal/MbConfirm";
import MbInputSelect2 from "@/components/ui/base/MbInputSelect2"
import MbUserAvatarSelect from "@/components/patient-new/MbUserAvatarSelect"
import MbClassAvatarSelect from "@/components/class-new/MbClassAvatarSelect"
import MbContentFind from "@/components/content-find/MbContentFind"
import MbContentReport from "@/components/content/MbContentReport";
import MbContentCaption from "@/components/content/MbContentCaption"
import MbGuidaWidget from './components/notice/MbGuidaWidget.vue';
import MbNoticeWidget from './components/notice/MbNoticeWidget.vue';
import MbStudentList from '@/components/student/MbStudentList.vue';
import MbGroupList from '@/components/student/MbGroupList.vue';
import MbSessionList from './components/session/MbSessionList.vue';
import MbSessionForm from './components/session/MbSessionForm.vue';
import MbStudentListContent from './components/student/MbStudentListContent.vue';
import MbExerciseStats from '@/components/exercise/MbExerciseStats.vue';
import MbBadgeWon from '@/components/badge/MbBadgeWon.vue';
import MbAttestato from '@/components/badge/MbAttestatoView.vue';

import MbChoseTheme from './components/navbar/MbChoseTheme.vue';

window.vueComponents = window.vueComponents || {}

Vue.config.productionTip = false

const Widgets = {
  "mb-alert": MbAlert,
  "mb-confirm": MbConfirm,
  "mb-input-select-2": MbInputSelect2,
  "mb-user-avatar-select": MbUserAvatarSelect,
  'mb-class-avatar-select': MbClassAvatarSelect,
  'mb-content-find': MbContentFind,
  'mb-content-report': MbContentReport,
  "mb-content-caption": MbContentCaption,
  "mb-guida-widget": MbGuidaWidget,
  "MbChoseTheme": MbChoseTheme,
  "mb-notice-widget": MbNoticeWidget,
  "mb-student-list": MbStudentList,
  "mb-group-list": MbGroupList,
  "mb-session-list": MbSessionList,
  "MbSessionForm": MbSessionForm,
  "MbStudentListContent": MbStudentListContent,
  "MbExerciseStats": MbExerciseStats,
  "MbBadgeWon": MbBadgeWon,
  "MbAttestato": MbAttestato,
}

const Components = {
};

const Filters = {
  Date,
  DateTime
};

document.addEventListener("DOMContentLoaded", function() {
  Object.keys(Widgets).forEach(name => {
    var els = document.getElementsByClassName(name);
    if (els.length == 0) {
      return;
    }

    Array.prototype.forEach.call(els, el => {
      var ComponentClass = Vue.extend(Widgets[name])
      var instance = new ComponentClass();

      for (let i = 0; i < el.attributes.length; i++) {
        var attrib = el.attributes[i];
        if (instance[attrib.name] != undefined){
          instance[attrib.name] = attrib.value;
        }
      }

      instance.$mount(el)
    });
  });

  window.MbCreateVue("mb-alert", "page-alert");
  window.MbCreateVue("mb-confirm", "page-confirm");
});

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);

  if (window.Vue){
    window.Vue.component(name, Components[name]);
  }
});

Object.keys(Filters).forEach(name => {
  Vue.filter(name, Filters[name]);

  if (window.Vue){
    window.Vue.filter(name, Filters[name]);
  }
});

window.MbCreateVue = function(widgetName, selector, parameters){
  var els = document.getElementsByClassName(selector);
  if (els.length == 0){
    return;
  }

  var el = els[0];

  var ComponentClass = Vue.extend(Widgets[widgetName])
  var instance = new ComponentClass();
  for(var p in parameters){
    instance[p] = parameters[p];
  }
  instance.$mount()
  el.appendChild(instance.$el)

  window.vueComponents[selector] = instance
  return instance
}
